import { Box, Typography } from '@mui/material';
import { ActionButtons } from './ActionButtons';
import { type INTEGRATIONS, INTEGRATIONS_V2 } from '../IntegrationButton';
import { type HandleSubmit } from '../../hooks';

type IntegrationsActionsProps = {
  pageSubtitle: string;
  integrationNameSource: INTEGRATIONS | INTEGRATIONS_V2;
  handleSubmit: HandleSubmit;
};

export const IntegrationsActions = ({
  pageSubtitle,
  integrationNameSource,
  handleSubmit
}: IntegrationsActionsProps) => {
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      columnGap={4}
      sx={{ flexDirection: { xs: 'column', sm: 'row' } }}
    >
      <Box>
        <Typography variant="h5">{pageSubtitle}</Typography>
      </Box>
      {integrationNameSource &&
        Object.values(INTEGRATIONS_V2).find(v2Integration => v2Integration === integrationNameSource) && (
          <ActionButtons onSubmit={handleSubmit} />
        )}
    </Box>
  );
};
